import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withAuthentication } from '~/hocs/withAuthentication';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

const List = withAuthentication(({ user }) => {
  if (user.permissions.federation_admin) {
    return (
      <Fragment>
        <p>Genom att du är förbundsadministratör så har du rättigheter till alla föreningar.</p>
        <p>
          Därför bör du istället använda dig utav <Link to="/clubs">föreningsregistret</Link>, som du även kommer åt via
          huvudmenyn.
        </p>
      </Fragment>
    );
  }

  if (!user.permissions.clubs_admin.length) {
    return <p>Du har inga föreningar som du administrerar för tillfället.</p>;
  }

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Förening</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {user.permissions.clubs_admin.map(club => (
          <Table.Row key={club.id}>
            <Table.Col>
              <Link to={`/clubs/${club.id}`}>{club.name}</Link>
            </Table.Col>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
});

export function Page() {
  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Mina föreningar" />
      </PageLayout.Header>

      <List />
    </Fragment>
  );
}
